<template>
  <section class="search-box-wrapper">
    <div class="container">
      <div class="columns justify-content-center">
        <div class="column is-10-tablet">
          <form @submit.prevent="searchProduct($event)" onSubmit="return false;">
            <div class="field search-box">
              <div class="control">
                <input v-model="searchText" @keyup.enter="searchProduct($event)" class="input" type="text" placeholder="Search for cannabis products">
                <span class="icon">
                  <img src="@/assets/img/icon-search.svg" alt="image">
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex"
export default {
  name: 'SearchProductBar',
  data() {
    return {
      searchText: '',
    };
  },
  
  computed: {
    ...mapGetters({
      vg_selectedLocation: "location/selected",
    }),
  },

  methods: {
    searchProduct() {
     this.$router.push({ 
        name: 'SearchProductResult', 
        params:{
          store_slug: this.vg_selectedLocation.slug,
        },
        query: { ...this.$route.query, ...{ product_name: this.searchText.trim() } }
      })
    },
  },
};
</script>